import { type UrlMatchResult, type UrlSegment } from '@angular/router';
import { baseRoutes } from '@bizzdesign/shared/utils';

/* This matcher is for path
   { path: 'home/search' }
*/
export const searchMatcher = (
  segments: UrlSegment[],
): UrlMatchResult | null => {
  return segments.length === 2 &&
    segments[0]?.path === baseRoutes.home &&
    segments[1]?.path === 'search'
    ? {
        consumed: segments,
        posParams: segments[1]?.path ? { context: segments[1] } : {},
      }
    : null;
};
